<template>
  <div class="main-content-container bg--light">
    <div class="top-content-container position-relative">
      <b-breadcrumb class="pb-2">
        <b-breadcrumb-item>
          <span
            class="text-uppercase font-family-medium"
            @click="$router.push({ name: 'DedicatedCustomers' })"
            >Customers</span
          >
        </b-breadcrumb-item>
      </b-breadcrumb>
      <h1 class="font-lg font-family-medium primary-dark content-title">
        Handover
      </h1>
      <div
        v-if="loaded && handoverCustomersList.length"
        class="position-absolute grid-icon-container"
      >
        <img
          v-if="!showListView"
          @click="showListView = !showListView"
          src="@/assets/icons/card_grid.svg"
          alt
          class="cursor-pointer"
        />
        <img
          v-if="showListView"
          @click="showListView = !showListView"
          src="@/assets/icons/card_list.svg"
          alt
          class="cursor-pointer"
        />
      </div>
      <b-dropdown-divider class="mb-5  mt-3 " />
    </div>

    <div v-if="!showListView" class="d-flex grid-card-wrapper">
      <b-row class="w-100 d-flex flex-column" no-gutters>
        <b-row class="">
          <b-col
            cols="6"
            md="4"
            lg="4"
            xl="3"
            v-for="item in handoverCustomersList"
            :key="item.customer.id"
          >
            <b-card
              @click="navigate(item)"
              no-body
              @mouseenter="showCardHover(item.customer.id)"
              @mouseleave="undoCardHover(item.customer.id)"
              class="grid-card mb-5"
            >
              <div class="d-flex justify-content-end"></div>
              <b-card-body class="text-center grid-card-body position-relative">
                <div class="position-relative">
                  <div class="grid-card-avatar-wrapper">
                    <b-avatar
                      class="customers-grid-avatar position-relative bg--primary"
                      size="12rem"
                      v-if="item.customer.avatarThumbnail"
                      :src="item.customer.avatarThumbnail"
                    ></b-avatar>
                    <b-avatar
                      class="customers-grid-avatar position-relative bg--primary"
                      size="12rem"
                      v-else
                      :text="
                        getInitials(
                          `${item.customer.firstName} ${item.customer.lastName}`
                        )
                      "
                    ></b-avatar>
                    <b-avatar
                      button
                      v-if="item.requestedBy.avatarThumbnail"
                      :src="item.requestedBy.avatarThumbnail"
                      :id="item.customer.id"
                      size="3.2rem"
                      @click="showHandover($event, item.customer.id)"
                      class="position-absolute handover-avatar"
                    ></b-avatar>
                    <b-avatar
                      v-else
                      button
                      :text="
                        getInitials(
                          `${item.requestedBy.firstName} ${item.requestedBy.lastName}`
                        )
                      "
                      :id="item.customer.id"
                      size="3.2rem"
                      @click="showHandover($event, item.customer.id)"
                      class="position-absolute handover-avatar bg--primary pa-avatar-handover"
                    ></b-avatar>
                    <div class="open-tasks-indicator font-size-sm" v-b-tooltip :title="`Number of open tasks: ${item.customer.openTasksCount}`">
                      {{ item.customer.openTasksCount }}
                    </div>
                    <b-popover
                      v-if="clickedMiniAvatarId === item.customer.id"
                      :target="item.customer.id"
                      custom-class="handover-popover"
                      placement="bottom"
                      :show="showHandoverPopup"
                      variant="primary"
                    >
                      <b-row
                        class="d-flex flex-column justify-content-center mx-0"
                      >
                        <h6 class="default-white ml-2">Handover by</h6>
                        <b-row
                          class="d-flex align-items-center reduce-whitespace-2"
                        >
                          <b-col md="4" class="d-flex pr-0 align-items-center">
                            <b-avatar
                              v-if="item.requestedBy.avatarThumbnail"
                              :src="item.requestedBy.avatarThumbnail"
                              size="4.4rem"
                            ></b-avatar>
                            <b-avatar
                              v-else
                              :text="
                                getInitials(
                                  `${item.requestedBy.firstName} ${item.requestedBy.lastName}`
                                )
                              "
                              size="4.4rem"
                              class="bg--primary pa-avatar"
                            ></b-avatar>
                          </b-col>
                          <b-col
                            md="8"
                            class="pl-0 position-relative"
                            style="right: 1rem"
                          >
                            <p class="default-white ml-4 mt-3 reduce-line-height">
                              {{
                                `${item.requestedBy.firstName} ${item.requestedBy.lastName}`
                              }}
                            </p>
                          </b-col>
                        </b-row>
                      </b-row>
                    </b-popover>
                  </div>
                </div>
                <p class="font-family-medium primary--text mt-5" :title="`${item.customer.firstName} ${item.customer.lastName}`">
                  {{ ellipsify(`${item.customer.firstName} ${item.customer.lastName}`, 25) }}
                </p>
                <div class="d-flex justify-content-center">
                  <b-button
                    class="reduce-whitespace-2 text-uppercase mr-2 btn-chip btn-danger--light danger font-family-regular btn-chip--pill"
                    >{{ item.customer.membership }}</b-button
                  >
                </div>
              </b-card-body>
            </b-card>
          </b-col>
        </b-row>
        <infinite-loading
          spinner="spiral"
          @infinite="infiniteHandlerHandoverCustomers"
          :identifier="infiniteId"
          ><div slot="no-more">
            <h4 class="primary--text font-family-medium mb-5 mt-5">
              No more customers to load.
            </h4>
          </div>
          <div slot="no-results">
            <h4 class="primary--text font-family-medium mb-5 mt-5">
              No more customers to load.
            </h4>
          </div></infinite-loading
        >
      </b-row>
    </div>

    <b-row v-if="showListView" no-gutters>
      <b-col :style="{ paddingRight: '15px' }"  cols="12" xl="6">
        <b-row class="" no-gutters>
          <b-col cols="6" class="heading-column">
            <h6 class="font-sm primary--text font-family-medium">
              Customer
            </h6>
          </b-col>
          <b-col class="heading-column" cols="6">
            <h6 class="font-sm primary--text font-family-medium">
              Handover by
            </h6>
          </b-col>
        </b-row>
      </b-col>
      <b-col :style="{ paddingLeft: '15px' }" cols="6" class="second-heading-column">
        <b-row no-gutters v-if="handoverCustomersList.length > 1" class="">
          <b-col cols="6" class="heading-column">
            <h6 class="font-sm primary--text font-family-medium">
              Customer
            </h6>
          </b-col>
          <b-col class="heading-column" cols="6">
            <h6 class="font-sm primary--text font-family-medium">
              Handover by
            </h6>
          </b-col>
        </b-row>
      </b-col>
    </b-row>

    <b-row v-if="showListView" class="mb-4 ml-0" no-gutters>
      <b-col
        class="grid-list-column"
        md="12"
        xl="6"
        lg="12"
        sm="12"
        cols="12"
        v-for="item in handoverCustomersList"
        :key="item.customer.id"
      >
        <b-card
          @click="navigate(item)"
          class="grid-list-card"
          no-body
          @mouseenter="showCardHover(item.customer.id)"
          @mouseleave="undoCardHover(item.customer.id)"
        >
          <b-card-body class="d-flex text-center grid-list-card-body py-4">
            <b-col md="6" xl="6" sm="6" cols="6" class="d-flex">
              <div class="grid-card-avatar-wrapper list-view">
                <b-avatar
                  size="8rem"
                  v-if="item.customer.avatarThumbnail"
                  :src="item.customer.avatarThumbnail"
                ></b-avatar>
                <b-avatar
                  class="bg--primary"
                  size="8rem"
                  v-else
                  :text="
                    getInitials(
                      `${item.customer.firstName} ${item.customer.lastName}`
                    )
                  "
                ></b-avatar>
                <div class="open-tasks-indicator font-size-sm" v-b-tooltip :title="`Number of open tasks: ${item.customer.openTasksCount}`">
                  {{ item.customer.openTasksCount }}
                </div>
              </div>
              <div class="d-flex flex-column align-items-start ml-4 mt-2">
                <p class="font-family-medium primary--text text-align-initial">
                  {{ ellipsify(`${item.customer.firstName} ${item.customer.lastName}`, 17) }}
                </p>
                <div class="d-flex justify-content-center reduce-whitespace-2">
                  <b-button
                    class="text-uppercase mr-2 btn-chip btn-danger--light danger font-family-regular btn-chip--pill"
                    >{{ item.customer.membership }}</b-button
                  >
                </div>
              </div>
            </b-col>

            <b-col md="6" class="d-flex align-items-center">
              <b-avatar
                v-if="item.requestedBy.avatarThumbnail"
                :src="item.requestedBy.avatarThumbnail"
                size="4.4rem"
              ></b-avatar>
              <b-avatar
                v-else
                class="pa-avatar bg--primary"
                :text="
                  getInitials(
                    `${item.requestedBy.firstName} ${item.requestedBy.lastName}`
                  )
                "
                size="4.4rem"
              ></b-avatar>
              <p
                style="width: 12rem;text-align: initial;"
                class="primary-dark font-family-medium ml-4 mt-2"
              >
                {{
                  `${item.requestedBy.firstName} ${item.requestedBy.lastName}`
                }}
              </p>
            </b-col>
          </b-card-body>
        </b-card>
      </b-col>
      <infinite-loading
        spinner="spiral"
        style="width:100%"
        @infinite="infiniteHandlerHandoverCustomers"
        :identifier="infiniteId"
        ><div slot="no-more">
          <h4 class="primary--text font-family-medium mb-5 mt-5">
            No more customers to load.
          </h4>
        </div>
        <div slot="no-results">
          <h4 class="primary--text font-family-medium mb-5 mt-5">
            No more customers to load.
          </h4>
        </div></infinite-loading
      >
    </b-row>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { getAssistantHandoverCustomers } from "@/apis/customers";
import { internalCustomerEmailSet } from "@/utils/constants";
import { getInitials, ellipsify } from "@/utils/utils";
export default {
  name: "HandoverCustomers",
  props: ["dedicated", "handover"],
  computed: {
    ...mapState("authModule", ["role", "profileUserId"])
  },
  data() {
    return {
      showListView: false,
      isLoadingHandoverCustomers: true,
      showHandoverPopup: false,
      clickedMiniAvatarId: "",
      assistantProfileId: "",
      handoverCustomersList: [],
      expandHover: false,
      offset: 0,
      loaded: false,
      infiniteId: +new Date(),
      activeExpandHoverId: "",
      inactiveExpandHoverId: "",
      showInactiveExpandHover: true,
      count: null
    };
  },
  methods: {
    getInitials,
    ellipsify,
    showCardHover(id) {
      this.activeExpandHoverId = id;
      this.expandHover = true;
      this.showInactiveExpandHover = true;
    },
    undoCardHover(id) {
      this.inactiveExpandHoverId = id;
      this.expandHover = false;
    },
    navigate(item) {
      this.$router.push({
        name: "CustomerDetails",
        params: {
          profileId: item.customer.id
        },
        query: {
          tab: 2
        }
      });
    },
    infiniteHandlerHandoverCustomers($state) {
      let data = {
        limit: 30,
        offset: this.offset
      };
      getAssistantHandoverCustomers(this.profileUserId, data)
        .then(res => {
          this.loaded = true;
          this.handoverCustomersList = [
            ...this.handoverCustomersList,
            ...res.data.results
          ].filter(
            el => !internalCustomerEmailSet.has(el.customer.email)
          );
          this.offset = res.data.offset;
          if (res.data.next === null) {
            $state.complete();
          } else {
            $state.loaded();
          }
        })
        .catch(err => {
          console.log(err.response);
        });
    },
    showHandover(event, assistant_id) {
      event.stopPropagation();
      this.clickedMiniAvatarId = assistant_id;
      if (this.clickedMiniAvatarId === assistant_id) {
        this.showHandoverPopup = !this.showHandoverPopup;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.grid-list-wrapper {
  margin-bottom: 4rem;
}
.grid-list-card {
}
.grid-card,
.grid-list-card {
  cursor: pointer;
}
.grid-list-column {
  padding-bottom: 20px;
}
.grid-card:not(:last-child) {
  margin-right: 2%;
}
.grid-card:last-child {
  margin-right: 0 !important;
}
.grid-icon-container {
  right: 0;
  bottom: 30%;
}
.grid-icon-container img {
  width: 21px;
  height: 21px;
}
.grid-list-action-icons {
  margin-top: -1.5rem;
  top: 40%;
  right: -1rem;
}
.expand-right {
  right: 0.8rem;
}
.handover-avatar {
  bottom: 0;
  left: 0%;
}
button.btn.close-btn {
  right: -2.5rem;
  top: -2rem;
  background: none;
}
@media screen and (min-width: 1920px) {
  .handover-avatar {
    left: 35%;
  }
}
.card-body.grid-card-body {
  padding-top: 35px;
}
.heading-column {
  padding-left: calc(1.25rem + 15px);
}
.heading-column:nth-child(2) {
  padding-left: 15px;
}
.heading-column:last-child {
  // padding-left: 15px;
}
@media (max-width: 1199px) {
  .second-heading-column {
    display: none;
  }
  .heading-column:nth-child(2) {
    padding-left: 22.5px;
  }
}
@media (min-width: 1200px) {
  .grid-list-column:nth-child(even) {
    padding-left: 15px;
  }
  .grid-list-column:nth-child(odd) {
    padding-right: 15px;
  }
}

</style>
